module.exports = __webpack_public_path__ + "audio-guide/img/vr.6a221b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/vr.png
// module id = RAeK
// module chunks = 1